// Infer the subscription type based on metadata first, then price/plan ID (legacy)
export function getSubscriptionType (subscription) {
  const subscriptionItem = subscription?.items?.data?.[0]

  // Custom plans
  const metaType = (
    subscriptionItem?.plan?.metadata?.dataType ||
    subscriptionItem?.plan?.metadata?.data_type ||
    ''
  ).toLowerCase()

  if (metaType === 'business') return 'business'
  if (metaType === 'people') return 'people'
  if (metaType === 'property') return 'property'
  if (metaType === 'product') return 'product'

  // dataType on the ID - fallback
  const priceId =
    subscriptionItem?.price?.id || subscriptionItem?.plan?.id || ''

  if (priceId.includes('business')) return 'business'
  if (priceId.includes('people')) return 'people'
  if (priceId.includes('property')) return 'property'
  if (priceId.includes('product')) return 'product'

  return null
}

// Find the latest subscription per type (business, people, property, product)
export function getLatestSubscriptionByType (subscriptions) {
  const latestSubscriptionsByType = {}

  for (const subscription of subscriptions || []) {
    const subscriptionType = getSubscriptionType(subscription)
    if (!subscriptionType) continue

    const currentLatest = latestSubscriptionsByType[subscriptionType]
    if (
      !currentLatest ||
      (subscription.current_period_end || 0) >
        (currentLatest.current_period_end || 0)
    ) {
      latestSubscriptionsByType[subscriptionType] = subscription
    }
  }

  return latestSubscriptionsByType
}
